import { createSlice } from "@reduxjs/toolkit";
import uuid from 'react-uuid';


  



const initialState={
    mode:'add',
   
    singleOrderData:{},
    totalAreaOfOrders:'',
      customerInfo:{
        customerId:'',
        customerLpi:[],
        dpiNames:[],
        designerId:'',
        klischeTypeCategory:''
      }


      ,
      colors:{
       selectedColors:{baseColor:[],additioanalColor:[]},
       countColors:1,
       orderColorsNames:[],
      }



      ,
      uploadImages:{
        orderImages:[],
        formImage:[]
      }


      ,
      machineInfo:{
      customerMachineList:[],
      machineId:'',
      dpiId:'',
      numberOfColors:0,
      machineDetails:{
       dpiList:[],
       cylinders:[],
       aniloxes:[],
       aniloxCount:0

      },
      machinesNamesList:[]
      }
      ,

    previouseOrder:{},
    asyncError:{},
    orderColorSelectedId:''
   
   
}

const setModuleMode=(state,{payload})=>{
  // console.log(payload)
  state.mode=payload;
}




const setSingleOrderData=(state,{payload})=>{
  let rawData={...payload,lpiId:payload?.lpi?.id,lpiValue:payload?.lpi.value,damageCauseId:'',klischeTypeId:'',fileStatuseId:'',organizationUnitId:''};
  let{lpi,...rest}=rawData;

  state.singleOrderData=rest;


  let baseColor=[];
  let additionalColors=[];
  let addiColorsNames=[];

  let totalCountOfColor = 0;
  let orderImages=payload?.uploadImages.filter(img=>img.imageSelectType===3).map(img=>{
    return {...img,storType:'saved'}
  });
  let FormImage=payload?.uploadImages.filter(img=>img.imageSelectType===1).map(img=>{
    return {...img,storType:'saved'}
  });






  state.colors.selectedColors.baseColor=payload?.colorSelections.forEach(color=>{
    if (color.isBase===true) {
        baseColor.push(color);
        totalCountOfColor+=color.countOfColor
    } 
    else {
        additionalColors.push(color);
        totalCountOfColor+=color.countOfColor
    }
  });

  addiColorsNames=payload?.colorSelections.map((color)=> color.colorValue);
  state.colors.orderColorsNames=addiColorsNames;

   
  state.uploadImages.orderImages=orderImages;
  state.uploadImages.formImage=FormImage;
  state.colors.selectedColors.baseColor=baseColor;
  state.colors.selectedColors.additioanalColor=additionalColors;
  state.colors.countColors=totalCountOfColor;



}















const setPreviouseNumber=(state,{payload})=>{
state.previouseOrder=payload;
}

const setCustomerId=(state,{payload:customerdata})=>{
const designerKeys = Object.entries(customerdata)
.filter(([key]) =>key.includes("mainDesignerId"))
.reduce((obj, [key, value]) => ({ ...obj, [key]: value }),{});
// console.log(designerKeys)
state.customerInfo.customerId=customerdata.customerId;
state.customerInfo.designerId=designerKeys.mainDesignerId

}



const updateColorSelected=(state,{payload:colorSelected})=>{
    let filtredColors={...colorSelected};
    filtredColors={baseColor:colorSelected.baseColor.map((color)=>{
     return color
    }),additioanalColor:colorSelected.additioanalColor.map(({countOfColor,...rest})=>{
        if (countOfColor>0) {
            return {countOfColor:countOfColor,...rest}
        }
    }).filter(obj => obj !== undefined)}
   
 state.colors.selectedColors=filtredColors;




 let totalCountOfColor = 0;
 Object.values(filtredColors).forEach(colorArray => {
    colorArray.forEach(color => {
      totalCountOfColor += color.countOfColor;
    });
  });
  state.colors.countColors=totalCountOfColor;



}

const updateFurtherInformation=(state,{payload})=>{
    let{name,value}=payload;
// console.log(name,value)
state.furtherInformation[name]=value;
}


const updateCustomerMachineInfo=(state,{payload})=>{
    state.machineInfo.customerMachineList=payload
    state.machineInfo.machinesNamesList=payload.map((machine)=>{
        return {key:machine.machineName,value:machine.machineInfoId}
    })
//   console.log(payload)
}

const fillMachineBasicInfo=(state,{payload})=>{
    
    let{name,value}=payload;
    let id=value;
     state.machineInfo.machineId=value;
    let machineSelected=state.machineInfo.customerMachineList.find((machine)=>machine.machineInfoId===value);
    state.machineInfo.numberOfColors=machineSelected.numberOfColors
     state.machineInfo.machineDetails.dpiList=[...machineSelected.dpiList].map((dpi)=>{
        return{key:dpi.dpi,value:dpi.id}
     }); 


}


const setDpiId=(state,{payload})=>{
    let{name,value}=payload;
    state.machineInfo[name]=value;

}


// declare Function after last change
const setOrderImages=(state,{payload})=>{
    const{type,data}=payload;
    // console.log(payload)
    const arraydata=Array.from(data);
    if (arraydata.length>0) {
        switch (type) {
            case 3:
                state.uploadImages.orderImages=[...state.uploadImages.orderImages,...arraydata.map((file)=>{
                    return{id:uuid(),picture:file,storType:'added',imageSelectType: 3,imageName:file.name,title:file.name,url: URL.createObjectURL(file)}
                })]
                break;
    
                case 1:
                    state.uploadImages.formImage=arraydata.map((file)=>{
                        return{id:uuid(),picture:file,storType:'added',imageSelectType: 1,imageName:file.name,title:file.name,url: URL.createObjectURL(file)}
                    })
        
            default:
                break;
        } 
    }
}


const setCustomerLpis=(state,{payload:lpiList})=>{
  // console.log(lpiList)
  let lpiNames=[...new Set(lpiList.map(lpi=>lpi.dpiValue))];
    state.customerInfo.customerLpi=lpiList;
    
}

const setKlischeTypeCategory=(state,{payload})=>{
  state.customerInfo.klischeTypeCategory=payload;
}

const clearAddedData=(state)=>{
  
    state.colors.countColors=0;
    state.uploadImages.orderImages=[];
    state.uploadImages.formImage=[];
    state.mode='add'
    state.singleOrderData={};
    state.customerInfo.klischeTypeCategory='';
    state.customerInfo.customerLpi=[];

}

const filterOrderImages=(state,{payload:imageDetails})=>{
let{id,type,added}=imageDetails;
// console.log(imageDetails)
if (type===3) {
  state.uploadImages.orderImages=state.uploadImages.orderImages.filter(img=>img.id!==id)
} else {
     state.uploadImages.formImage=state.uploadImages.formImage.filter(img=>img.id!==id)
}

}

const setCountOfColor=(state,{payload})=>{
let{colors,op}=payload;
// console.log(payload)
let totalCount=0;
if (op==='blur') {
  colors.forEach((color)=>{
    totalCount+=color.countOfColor
  })
  state.colors.countColors=totalCount;
}
else if(op==='delete') {
  state.colors.countColors-=colors;
}
// totalSum
else if(op==='totalSum'){
 state.colors.countColors=colors
}

else if(op==='pluseOne') {
  state.colors.countColors+=1;
}



}



const setAsyncError=(state,{payload})=>{
// console.log(payload)
state.asyncError=payload;
}


const setMachieDetails=(state,{payload})=>{
// console.log(payload)
let{aniloxInfoList}=payload;
state.machineInfo.machineDetails.aniloxes=aniloxInfoList;
// state.machineInfo.machineDetails.aniloxCount=aniloxInfoList.length

}

const filterMachineAnilux=(state,{payload:id})=>{
// console.log(id);
let filterd=state.machineInfo.machineDetails.aniloxes.filter((ani)=>ani.id!==id);
state.machineInfo.machineDetails.aniloxes=filterd;

}

const resetOrderFormData=(state)=>{
  state.colors.countColors=0
  state.machineInfo.machineDetails.aniloxCount=0
}


const setOrderColorSelectedId=(state, { payload })=>{
  state.orderColorSelectedId=payload
}

// totalAreaOfOrders
const setTotalAreaOfOrders=(state, { payload })=>{
  let totalArea=0;
  state.totalAreaOfOrders=payload;
}






const OrderOnlineSlice=createSlice({
    name:'OrderOnline',
    initialState,
    reducers:{
        setSingleOrderData,
        setModuleMode,

        setPreviouseNumber,
        setCustomerId,
        updateColorSelected,
        updateFurtherInformation,
        updateFurtherInformation,
        updateCustomerMachineInfo,
        fillMachineBasicInfo,
        setDpiId,
        setOrderImages,
        setCustomerLpis,
        clearAddedData,
        filterOrderImages,
        setKlischeTypeCategory,
        setAsyncError,
        filterMachineAnilux,
        resetOrderFormData,
        setOrderColorSelectedId,
        setCountOfColor,
        setMachieDetails,
        setTotalAreaOfOrders
        
    }
})





    export const { 
        setModuleMode:setModuleModeR,
        setPreviouseNumber:setPreviouseNumberR,
        setCustomerId:setCustomerIdR,
        updateColorSelected:updateColorSelectedR,
        updateFurtherInformation:updateFurtherInformationR,
        updateCustomerMachineInfo:updateCustomerMachineInfoR,
        fillMachineBasicInfo:fillMachineBasicInfoR,
        setDpiId:setDpiIdR,
        setOrderImages:setOrderImagesR,
        setCustomerLpis:setCustomerLpisR,
        clearAddedData:clearAddedDataR,
        filterOrderImages:filterOrderImagesR,
        setSingleOrderData:setSingleOrderDataR,
        setKlischeTypeCategory:setKlischeTypeCategoryR,
        setAsyncError:setAsyncErrorR,
        filterMachineAnilux:filterMachineAniluxR,
        setTest:setTestR,
        resetOrderFormData:resetOrderFormDataR,
        setTotalAreaOfOrders:setTotalAreaOfOrdersR,
       





        setCountOfColor:setCountOfColorR,
        setMachieDetails:setMachieDetailsR,
        setOrderColorSelectedId:setOrderColorSelectedIdR


                 }=OrderOnlineSlice.actions

     export default OrderOnlineSlice.reducer